export default __webpack_public_path__ + "static/media/payment-scan.c7054f6c.svg";